const urlParams = new URLSearchParams(window.location.search);
const campaignParameters = {
  channel: "source",
  source: "source",
  medium: "medium",
  utm_source: "source",
  utm_medium: "medium",
  utm_campaign: "utm_campaign",
  adgroup_id: "adgroupid",
  adgroupid: "adgroupid",
  utm_term: "utm_term",
  utm_content: "utm_content",
};

class CampaignService {
  init = () => {
    let availableParameters = [];

    Object.keys(campaignParameters).forEach((campaignParameterKey) => {
      if (urlParams.get(campaignParameterKey)) {
        availableParameters.push(campaignParameterKey);
      }
    });

    for (const availableParameter of availableParameters) {
      sessionStorage.setItem(
        availableParameter,
        urlParams.get(availableParameter)
      );
    }
  };

  get = () => {
    let availableParameters = [];

    Object.keys(campaignParameters).forEach((campaignParameterKey) => {
      if (sessionStorage.getItem(campaignParameterKey)) {
        availableParameters[campaignParameterKey] =
          sessionStorage.getItem(campaignParameterKey);
      }
    });

    return availableParameters;
  };
}

export default new CampaignService();
